export let Action = /*#__PURE__*/function (Action) {
  Action["Click"] = "Click";
  Action["View"] = "View";
  return Action;
}({});
export let Feature = /*#__PURE__*/function (Feature) {
  Feature["BankingLauncher"] = "Banking Launcher";
  return Feature;
}({});
export let Page = /*#__PURE__*/function (Page) {
  Page["ActivationUpsell"] = "Activation Upsell";
  return Page;
}({});
export let Target = /*#__PURE__*/function (Target) {
  Target["Homepage"] = "Homepage";
  Target["CheckingAccount"] = "Checking Account";
  Target["SavingsAccount"] = "Savings Account";
  Target["CheckingXsell"] = "Checking Xsell";
  Target["SavingsXsell"] = "Savings Xsell";
  Target["LoanOffer"] = "Loan Offer";
  Target["Loan"] = "Loan";
  Target["BalanceCardViewLoan"] = "Balance Card View Loan";
  Target["BalanceCardViewOffer"] = "Balance Card View Offer";
  Target["Learn"] = "Learn";
  Target["ActivateDebitCard"] = "Activate Now";
  return Target;
}({});
const getEventName = (action, feature) => `${action} ${feature}`;
export function getEvent(action, args) {
  const feature = Feature.BankingLauncher;
  return {
    name: getEventName(action, feature),
    properties: {
      feature,
      applet: 'Banking',
      ...args
    }
  };
}